(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
(() => {
  // Plusieurs formulaires de contact par page (tiroir devis, contact, devis) : Shopify signale l'envoi à tous.
  // On n'affiche la confirmation que sur le formulaire réellement envoyé (ancre #id conservée après l'envoi).
  if (window.__henryPostedFix) return;
  window.__henryPostedFix = true;
  const run = () => document.querySelectorAll('[data-posted-for]').forEach(f => {
    const done = f.querySelector('.form-done'), body = f.querySelector('.form-body');
    if (!done || done.hidden) return;
    if (location.hash.slice(1) === f.dataset.postedFor) { done.focus({ preventScroll: true }); return; }
    done.hidden = true;
    if (body) body.hidden = false;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
(() => {
  // Liste « Boutique » : la fiche de gauche (adresse, téléphone, horaires) suit la boutique choisie.
  // Objet « … H.BERNATHE » : la boutique passe sur Marseillan.
  const init = root => root.querySelectorAll('[data-contact-shop-select]').forEach(sel => {
    if (sel.dataset.ready) return; sel.dataset.ready = '1';
    const sec = sel.closest('section'), subject = sec && sec.querySelector('select[name="contact[Objet]"]');
    const show = () => {
      const n = sel.selectedOptions[0] && sel.selectedOptions[0].dataset.shop;
      sec.querySelectorAll('[data-contact-shop]').forEach(dl => { const on = dl.dataset.contactShop === n; dl.hidden = !on; if (on) { dl.classList.remove('shop-in'); void dl.offsetWidth; dl.classList.add('shop-in'); } });
    };
    sel.addEventListener('change', show);
    if (subject) subject.addEventListener('change', () => {
      if (!/bernathe/i.test(subject.value)) return;
      const o = [...sel.options].find(x => x.dataset.shop === '2');
      if (o && !o.selected) { o.selected = true; show(); }
    });
  });
  init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-split"] && !Shopify.designMode) return;
  try {
    
(() => {
  /* Montants de la carte cadeau : sélection sur place, met à jour le bouton d'ajout au panier. */
  const init = root => {
    root.querySelectorAll('[data-gift-split]').forEach(sec => {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      const btn = sec.querySelector('[data-add-variant]'), out = sec.querySelector('[data-gift-amount]');
      if (!btn) return;
      const chips = [...sec.querySelectorAll('[data-gift-variant]')];
      chips.forEach(c => c.addEventListener('click', e => {
        e.preventDefault();
        chips.forEach(x => x.removeAttribute('aria-current'));
        c.setAttribute('aria-current', 'true');
        btn.dataset.addVariant = c.dataset.giftVariant;
        if (out) out.textContent = c.dataset.giftLabel;
      }));
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-marquee"] && !Shopify.designMode) return;
  try {
    
(() => {
  // Bande de presse : défilement continu + défilement libre (glisser, élan, molette horizontale)
  const init = sec => {
    if (!sec || sec.dataset.pmReady) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return; // défilement manuel natif (CSS du thème)
    const mq = sec.querySelector('.marquee'), track = sec.querySelector('.marquee-track'), group = sec.querySelector('.marquee-group');
    if (!mq || !track || !group) return;
    sec.dataset.pmReady = '1';
    mq.classList.add('is-free');
    let x = 0, v = 0, half = 0, speed = 0, dragging = false, moved = 0, lastX = 0, lastT = 0, prev = performance.now(), visible = true, kbd = false;
    // Navigation au clavier : la bande s'arrête tant qu'un bouton « Lire l'article complet » a le focus
    mq.addEventListener('focusin', e => { kbd = e.target.matches(':focus-visible'); });
    mq.addEventListener('focusout', () => { kbd = false; });
    const measure = () => {
      half = group.getBoundingClientRect().width;
      const dur = parseFloat(getComputedStyle(mq).getPropertyValue('--dur')) || 90;
      speed = half / dur;
    };
    measure();
    addEventListener('resize', measure);
    if ('IntersectionObserver' in window) new IntersectionObserver(es => { visible = es[0].isIntersecting; }).observe(mq);
    const tick = t => {
      const dt = Math.min(0.05, (t - prev) / 1000); prev = t;
      if (visible && !dragging) {
        const auto = sec.classList.contains('paused') || kbd ? 0 : speed;
        x += (auto + v) * dt;
        v *= Math.pow(0.05, dt);              // l'élan retombe en douceur
        if (Math.abs(v) < 4) v = 0;
      }
      if (half) x = ((x % half) + half) % half; // boucle infinie (deux moitiés identiques)
      track.style.transform = `translate3d(${-x}px,0,0)`;
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
    mq.addEventListener('pointerdown', e => {
      if (e.button !== 0) return;
      dragging = true; moved = 0; v = 0; lastX = e.clientX; lastT = performance.now();
    });
    mq.addEventListener('pointermove', e => {
      if (!dragging) return;
      const dx = e.clientX - lastX, now = performance.now(), dt = Math.max(0.008, (now - lastT) / 1000);
      moved += Math.abs(dx);
      if (moved > 4 && !mq.classList.contains('is-drag')) { mq.classList.add('is-drag'); try { mq.setPointerCapture(e.pointerId); } catch (err) {} }
      x -= dx;
      v = Math.max(-3000, Math.min(3000, -dx / dt));
      lastX = e.clientX; lastT = now;
    });
    const end = () => {
      if (!dragging) return;
      dragging = false;
      if (performance.now() - lastT > 120) v = 0;  // relâché sans mouvement : pas d'élan
      mq.classList.remove('is-drag');
    };
    mq.addEventListener('pointerup', end);
    mq.addEventListener('pointercancel', end);
    mq.addEventListener('lostpointercapture', end);
    mq.addEventListener('click', e => { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
    mq.addEventListener('dragstart', e => e.preventDefault());
    mq.addEventListener('wheel', e => {
      const d = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : 0;   // pavé tactile / molette horizontale
      if (!d) return;
      e.preventDefault(); x += d; v = 0;
    }, { passive: false });
  };
  const run = () => document.querySelectorAll('.press-sec').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
(() => {
  const load = el => {
    if (el.dataset.loaded) return;
    el.dataset.loaded = '1';
    fetch(el.dataset.url)
      .then(r => (r.ok ? r.text() : ''))
      .then(html => {
        if (!html) return;
        const n = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recommend]');
        if (!n || !n.innerHTML.trim()) return;
        el.innerHTML = n.innerHTML;
        requestAnimationFrame(() => el.querySelectorAll('.reveal').forEach(x => x.classList.add('in')));
      })
      .catch(() => {});
  };
  const init = root => root.querySelectorAll('[data-recommend][data-url]').forEach(el => {
    if (!('IntersectionObserver' in window)) return load(el);
    const io = new IntersectionObserver(entries => {
      if (entries.some(e => e.isIntersecting)) { io.disconnect(); load(el); }
    }, { rootMargin: '600px 0px' });
    io.observe(el);
  });
  init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-form"] && !Shopify.designMode) return;
  try {
    
(() => {
  // Voir contact-form : la confirmation ne s'affiche que sur le formulaire réellement envoyé.
  if (window.__henryPostedFix) return;
  window.__henryPostedFix = true;
  const run = () => document.querySelectorAll('[data-posted-for]').forEach(f => {
    const done = f.querySelector('.form-done'), body = f.querySelector('.form-body');
    if (!done || done.hidden) return;
    if (location.hash.slice(1) === f.dataset.postedFor) { done.focus({ preventScroll: true }); return; }
    done.hidden = true;
    if (body) body.hidden = false;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-gallery"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__henryLightbox) return;
  window.__henryLightbox = true;
  document.addEventListener('click', e => {
    const open = e.target.closest('.lb-open');
    const root = open && open.closest('[data-lightbox-root]');
    const dlg = root && root.querySelector('[data-lb]');
    if (!dlg || !dlg.showModal) return;
    const items = [...root.querySelectorAll('.lb-open')];
    let i = items.indexOf(open);
    const img = dlg.querySelector('[data-lb-img]'), cap = dlg.querySelector('[data-lb-cap]'), num = dlg.querySelector('[data-lb-n]');
    const show = () => {
      const it = items[i];
      img.src = it.dataset.lbSrc; img.alt = it.dataset.lbAlt || '';
      cap.textContent = it.dataset.lbCaption || '';
      if (num) num.textContent = (i + 1) + ' / ' + items.length;
    };
    const step = d => { i = (i + d + items.length) % items.length; show(); };
    if (!dlg.dataset.ready) {
      dlg.dataset.ready = '1';
      dlg.addEventListener('click', ev => {
        const st = ev.target.closest('[data-lb-step]');
        if (st) return dlg._step(+st.dataset.lbStep);
        if (ev.target.closest('[data-lb-close]') || ev.target === dlg) dlg.close();
      });
      dlg.addEventListener('keydown', ev => {
        if (ev.key === 'ArrowRight') dlg._step(1);
        if (ev.key === 'ArrowLeft') dlg._step(-1);
      });
      dlg.addEventListener('close', () => { document.body.style.overflow = ''; if (dlg._from) dlg._from.focus({ preventScroll: true }); });
    }
    dlg._step = step;
    dlg._from = open;
    show();
    document.body.style.overflow = 'hidden';
    dlg.showModal();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-sketches"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__henrySketch) return;
  window.__henrySketch = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('js-sk');
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('is-drawn'); io.unobserve(e.target); }
  }), { threshold: 0.35 });
  const watch = () => document.querySelectorAll('[data-sketch]:not(.is-drawn)').forEach(el => io.observe(el));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-video"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    const v = root.querySelector('[data-qv-video]'), b = root.querySelector('[data-qv-toggle]');
    if (!v || root.dataset.qvReady) return;
    root.dataset.qvReady = '1';
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    let paused = reduced, visible = false;
    const sync = () => {
      if (b) { b.setAttribute('aria-pressed', String(paused)); b.setAttribute('aria-label', paused ? 'Lire la vidéo' : 'Mettre la vidéo en pause'); }
      if (!paused && visible) { v.preload = 'auto'; const p = v.play(); if (p && p.catch) p.catch(() => {}); } else v.pause();
    };
    if (b) { b.hidden = false; b.addEventListener('click', () => { paused = !paused; sync(); }); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(es => es.forEach(e => { visible = e.isIntersecting; sync(); }), { threshold: 0.2 }).observe(root);
    } else { visible = true; sync(); }
  };
  const run = () => document.querySelectorAll('[data-qv]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();
})();
